import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from '../components/navbar/Navbar';
import { IRoute } from './interfaces/IRoute';
import ProjectTopicSidebar from '../components/projectTopic/ProjectTopicSidebar';
import { UserRoles } from '../utils/utils';

export const renderRoutesWithLayout = (
    routes: IRoute[],
    currentUserRole: UserRoles,
    classes?: string
) => {
    return (
        <Routes>
            {routes.map((value, index) => (
                <Route
                    key={value.path + index}
                    path={value.path}
                    element={addLayoutToComponent(
                        value.element,
                        value.activeNavItem ?? '',
                        currentUserRole,
                        classes
                    )}
                ></Route>
            ))}
        </Routes>
    );
};

export const addLayoutToComponent = (
    component: React.ReactNode,
    activeNavItem: string,
    currentUserRole: UserRoles,
    classes?: string
) => {
    return (
        <Fragment>
            <Navbar activeNavItem={activeNavItem} />
            <div className={`main-content ${classes ?? ''}`}>
                <div className='container-fluid'>
                    {component}{' '}
                    {currentUserRole !== UserRoles.admin &&
                        currentUserRole !== UserRoles.unauthenticated && (
                            <ProjectTopicSidebar />
                        )}
                </div>
            </div>
        </Fragment>
    );
};
